// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"BW-z","categoryName":"CW-z","categoryNameSearchHeader":"DW-z","categoryContent":"EW-z","bottomAligned":"FW-z","image":"GW-z","imageNoBackground":"HW-z"};